import { useNavigate, useParams } from 'react-router-dom';
import { EnrollmentStep1 } from '@fittrack/ui';
import { useMember } from '../context/MemberContext';
import { config } from '../config';
import '../pages/EnrollPage.css';

export default function EnrollJoinStep1Page() {
  const { member } = useMember();
  const navigate = useNavigate();
  const { packageId } = useParams<{ packageId: string }>();

  if (!member?.siteId) {
    return (
      <div className="enroll-page">
        <p className="enroll-empty">No site information available.</p>
      </div>
    );
  }

  return (
    <div className="enroll-page">
      <EnrollmentStep1
        companyId={config.onlineName}
        siteId={member.siteId}
        packageId={Number(packageId) || 0}
        apiUrl={config.apiUrl}
        authToken={sessionStorage.getItem('apiKey') ?? undefined}
        recaptchaSiteKey={config.recaptchaSiteKey}
        prefill={{
          firstName: member.firstName,
          lastName: member.lastName,
          email: member.email,
        }}
        onSuccess={(enrollmentKey) => {
          navigate(`/enroll/join/${packageId}/step2?key=${encodeURIComponent(enrollmentKey)}`);
        }}
        onCancel={() => navigate('/enroll')}
      />
    </div>
  );
}
